<!--
  -  Copyright (c) Qwoach LLC 2020. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 01/01/2019
  -->

<script>

import BaseDataComponent from "@/core/components/BaseDataComponent.vue";
import {qwDebounce} from "@shared/QwDebounce";

export default {
	extends: BaseDataComponent,
	name: "BaseVModelView",

	// inheritAttrs: false,

	emits: [
		'update:modelValue',
		'change',
		'changeImmediate',
	],

	props: {
		// value: null,
		modelValue: null,
		formatDataInProp: Function,
		formatDataOutProp: Function,
		inputDebounceDelay: Number,
		disableDebounce: Boolean,
		flushOnUnmount: {type: Boolean, default: false},
	},

	watch: {
		inputDebounceDelay: {
			immediate: true,
			handler(newValue) {
				if(!this.disableDebounce){
					// console.log("BaseVModelView: inputDebounceDelay changed to ", newValue, " for ", this.componentNameId)
				}
				if (newValue > 0 && !this.fireChangeEventDebounced && !this.disableDebounce) {
					this.fireChangeEventDebounced = qwDebounce(this.fireChangeEvent, this.inputDebounceDelay);
					this.fireChangeEvent = this.fireChangeEventDebounced
				} else if (newValue <= 0 && this.fireChangeEventDebounced) {
					this.fireChangeEvent = this.fireChangeEventDebounced.original()
					this.fireChangeEventDebounced.cancel()
					this.fireChangeEventDebounced = null
				}
			},
		},
		modelValue: {
			immediate: true,
			handler(newVal, oldVal) {
				// console.log("BaseVModelView: this.valueData = ", this.valueData, ", newVal = ", newVal, ", oldVal = ", oldVal)
				this.notifyIncomingValueChanged()
			},
		},
		value: {
			immediate: true,
			handler(newVal, oldVal) {
				// console.log("BaseVModelView: this.valueData = ", this.valueData, ", newVal = ", newVal, ", oldVal = ", oldVal)
				this.notifyIncomingValueChanged()
			},
		},
	},

	data() {
		return {
			valueData: null,
			fireChangeEventDebounced: null,
		}
	},

	mounted(){

		this.onIncomingValueChanged(this.modelValue)
	},
	beforeUnmount(){
		if (this.flushOnUnmount && this.fireChangeEventDebounced?.isDebouncePending?.()) {
			this.fireChangeEventDebounced.callImmediately()
		}
	},

	methods: {

		notifyIncomingValueChanged(){
			// console.log("BaseVModelView: notifyIncomingValueChanged = ", this.valueData, ", newVal = ", this.value)
			this.valueData = this.formatInInternal(this.modelValue)
			this.onValueChanged(this.modelValue)
		},

		onIncomingValueChanged(newVal){

		},

		onValueChanged(newVal){

		},

		formatDataIn(data) {
			return data
		},

		formatDataOut(data) {
			return data
		},

		notifyValueChanged(options = {}) {
			console.log("BaseVModelView.notifyValueChanged: this.valueData = ", this.valueData, ", this.componentNameId = ", this.componentNameId)
			return this.notifyValueChangedInternal(options)
		},

		notifyValueChangedImmediate(){
			console.log("BaseVModelView.notifyValueChangedImmediate, this.valueData = ", this.valueData, ", this.componentNameId = ", this.componentNameId);
			this.notifyValueChangedInternal({
				immediate: true
			})
		},

		getValueDataOut() {
			return this.formatOutInternal(this.valueData)
		},

		onBlur(){
			// if(this.$attrs.onBlur){
			// 	this.$attrs.onBlur()
			// }
			this._onBlurInternal()
		},

		_onBlurInternal(){
			let res = this.fireChangeEventDebounced?.isDebouncePending()
			console.log("BaseVModelView._onBlurInternal: this.isDebouncePending = ", res, ", this.componentNameId = ", this.componentNameId)
			if(res){
				this.notifyValueChangedImmediate()
			}
		},


		notifyValueChangedInternal(options = {}) {
			let data = this.getValueDataOut()

			this.$emit('update:modelValue', data)
			this.$emit('changeImmediate', data, options)

			console.log("BaseVModelView.notifyValueChangedInternal: options.immediate = ", options.immediate, ", has this.fireChangeEventDebounced = ", !!this.fireChangeEventDebounced, ", this.componentNameId = ", this.componentNameId)
			if(options.immediate && this.fireChangeEvent.callImmediately){
				this.fireChangeEvent.callImmediately(options)
			} else {
				this.fireChangeEvent(options)
			}

			return data
		},

		fireChangeEvent(options = {}) {
			let data = this.getValueDataOut()
			console.log("BaseVModelView.fireChangeEvent: data = ", data, ", this.componentNameId = ", this.componentNameId)
			this.$emit('change', data, options)
		},

		formatInInternal(value) {
			// console.trace("BaseVModelView: formatInInternal: value = ", value)
			if(this.formatDataInProp){
				return this.formatDataInProp(value)
			}
			return this.formatDataIn(value)
		},

		formatOutInternal(value) {
			// console.log("BaseVModelView: formatOutInternal: value = ", value)
			if(this.formatDataOutProp){
				return this.formatDataOutProp(value)
			}
			return this.formatDataOut(value)
		},
	},

	computed: {


		loadDataOnStartComputed(){
			return false
		},

		value: {
			get: function (){
				return this.modelValue
			},
		},
	}

}
</script>

<style>

</style>
